import React from 'react'
import { TooltipLink } from 'components'
import classnames from 'classnames'
import { BsInfoCircle } from 'react-icons/bs'
import styled from 'styled-components'

const InfoTooltipLink = ({ text, className, link, placement ,...rest }) => {
  return (
    <TooltipLink text={text} link={link} placement={placement} className={className}>
      <InfoCircle className={classnames('edit-mode')} {...rest} />
    </TooltipLink>
  )
}

export const InfoCircle = styled(BsInfoCircle)`
  color: rgba(109, 177, 251, 1);
  font-size: 15px;
  cursor: pointer;
  margin-bottom: 2px;

  &:hover {
    color: rgba(41, 127, 219, 1);
  }
`

export default InfoTooltipLink
